import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

const NOTIFICATION_TYPES = {
	success: NotificationType.Success,
	error: NotificationType.Error,
	warning: NotificationType.Warning,
} as const;

// Rejections are swallowed because an installed binary built before the plugin was added still
// runs the current web bundle under live reload, and feedback is never worth an error.
const ignore = () => {};

export function hapticTap(): void {
	if (Capacitor.isNativePlatform()) Haptics.impact({ style: ImpactStyle.Light }).catch(ignore);
}

export function hapticNotify(type: keyof typeof NOTIFICATION_TYPES): void {
	if (Capacitor.isNativePlatform()) Haptics.notification({ type: NOTIFICATION_TYPES[type] }).catch(ignore);
}

function isToggleInput(target: EventTarget | null): boolean {
	return target instanceof HTMLInputElement && (target.type === 'checkbox' || target.type === 'radio');
}

/** Taps on every switch, checkbox, chip and segmented-control change without touching each call site. */
export function installToggleHaptics(): void {
	if (!Capacitor.isNativePlatform()) return;

	document.addEventListener(
		'change',
		event => {
			if (isToggleInput(event.target)) hapticTap();
		},
		true,
	);
}
